import { useEffect } from 'react'
import { userData, nextCheck } from '@signals'

const USER_DATA_KEY = 'rentacar_user_data'
const NEXT_CHECK_KEY = 'rentacar_next_check'

export default function useLocalStorage() {
	useEffect(() => {
		if (userData.value && Object.keys(userData.value).length > 0) {
			localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData.value))
		} else {
			localStorage.removeItem(USER_DATA_KEY)
		}
	}, [userData.value])

	useEffect(() => {
		if (nextCheck.value) {
			localStorage.setItem(NEXT_CHECK_KEY, JSON.stringify(nextCheck.value))
		} else {
			localStorage.removeItem(NEXT_CHECK_KEY)
		}
	}, [nextCheck.value])

	const clearUserData = () => {
		localStorage.removeItem(USER_DATA_KEY)
		localStorage.removeItem(NEXT_CHECK_KEY)
	}

	return {
		clearUserData
	}
} 